<template>
  <div class="market">
    <img src="@/assets/images/market_bg.png" alt="" class="img-fluid" />
    <div class="container type-block">
      <span
        class="type"
        :class="{ active: currentType === index }"
        :key="index"
        v-for="(type, index) in typeList"
        @click="selectType(index)"
        >{{ type }}</span
      >
    </div>
    <div class="container project-container">
      <project-list
        v-if="projectList.length > 0"
        :list="projectList"
        :isShowPagination="true"
        :hasNext="hasNext"
        :hasLast="hasLast"
        @next="next"
        @last="last"
      ></project-list>
      <div v-else class="noresult">
        <img src="@/assets/images/noresult.png" class="mb-3" alt="" />
        <p class="prompt">搜索不到该项目~</p>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectList from '@/components/ProjectList';
import ApiService from '@/common/api.service';
import { mapGetters } from 'vuex';
import qs from 'qs';
import { shuffle } from '@/common/utils';
export default {
  data() {
    return {
      // type 0 全部
      // type 1  热门
      // type 2  最新
      currentType: 0,
      typeList: ['全部', '热门项目', '最新项目'],
      projectList: [],
      // projectList: Array(6).fill({
      //   name: 'APP二次开发，增加扫码功能APP二次开发',
      //   type: '类别：软件设计 > APP开发',
      //   price: '预算：￥10,000',
      //   date: '2019/08/20'
      // }),
      pageNo: 1,
      count: 0,
      pageSize: 10,
      keyword: ''
    };
  },
  computed: {
    hasNext() {
      return (
        this.count > (this.pageNo - 1) * this.pageSize + this.projectList.length
      );
    },
    hasLast() {
      return this.pageNo > 1;
    },
    ...mapGetters(['token'])
  },
  watch: {
    $route(to) {
      this.keyword = to.query.projectName;
      this.search();
    }
  },
  components: {
    ProjectList
  },
  created() {
    if (this.$route.query && this.$route.query.projectName) {
      this.keyword = this.$route.query.projectName;
      this.search();
    } else {
      this.getAll();
    }
  },
  methods: {
    initPagination() {},
    search() {
      this.pageNo = 1;
      this.count = 0;
      let data = {
        projectName: this.keyword,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      ApiService.post(
        '/orderInterface/serachOrderMsg.htm',
        qs.stringify(data)
      ).then(data => {
        this.count = data.count;
        this.projectList = data.list;
      });
    },
    getAll() {
      ApiService.post(
        '/orderInterface/serachOrderMsg.htm',
        qs.stringify({
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
      ).then(data => {
        this.count = data.count;
        this.projectList = data.list;
      });
    },
    getElse() {
      ApiService.post(
        '/orderInterface/serachOrderMsgNew.htm',
        qs.stringify({
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
      ).then(data => {
        this.count = data.count;
        this.projectList = data.list;
      });
    },
    next() {
      this.pageNo++;
      this.getList();
      this.toTop();
    },
    last() {
      if (this.pageNo == 1) {
        return;
      }
      this.pageNo--;
      this.getList();
      this.toTop();
    },
    getList() {
      if (this.$route.query && this.$route.query.projectName) {
        debugger;
        this.search();
      } else {
        if (this.currentType === 0) {
          this.getAll();
        } else {
          this.getElse();
        }
      }
    },
    selectType(type) {
      let tmp = this.currentType;
      this.currentType = type;
      this.pageNo = 1;
      this.count = 0;
      if (this.currentType === 0) {
        this.getAll();
      } else {
        if (tmp !== this.currentType && tmp !== 0) {
          this.projectList = shuffle(this.projectList);
        } else {
          this.getElse();
        }
      }
    },
    toTop() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }
};
</script>

<style lang="scss" scoped>
.market {
  .type-block {
    height: 5.63rem;
    text-align: center;
    .type {
      line-height: 5.63rem;
      height: 100%;
      display: inline-block;
      color: #666;
      margin-right: 2.5rem;
      &:hover {
        cursor: pointer;
      }
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: $acentColor;
      }
    }
  }
  .project-container {
    .noresult {
      text-align: center;
      .prompt {
        font-size: 1.13rem;
        color: #999999;
      }
    }
  }
}
</style>
